var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("node", {
    attrs: {
      title: _vm.config.name,
      "show-error": _vm.showError,
      content: _vm.content,
      "error-info": _vm.errorInfo,
      placeholder: "请设置延时时间",
      "header-bgc": "#f25643",
      "header-icon": "el-icon-time",
    },
    on: {
      selected: function ($event) {
        return _vm.$emit("selected")
      },
      delNode: function ($event) {
        return _vm.$emit("delNode")
      },
      insertNode: (type) => _vm.$emit("insertNode", type),
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }